<template>
  <AppDialog
    append-to-body
    class="new-referral-dialog"
    title="Refer companies to Hubstaff and earn a $300 cash bonus."
    :show="show"
    :subtitle="subtitle"
    position="centered"
    @close="close"
  >
    <div class="form-group d-flex justify-content-center align-items-center flex-column">
      <div class="actions">
        <AppInput
          v-model="email"
          placeholder="Email address"
          maxlength="100"
          class="email"
          type="email"
        ></AppInput>

        <span class="help-block">{{ errors }}</span>
      </div>

      <AppButton
        type="primary"
        class="send-invite"
        :disabled="!email || sending"
        @click="sendInvite(email)"
      >
        {{ sendEmailButtonText }}
      </AppButton>
    </div>

    <div class="referral-link">
      <label class="control-label">Your referral link</label>
      <AppCopyInputValue
        analytics-event-source="referral-dialog"
        button-text="Copy link"
        :value="referralLink"
      ></AppCopyInputValue>
    </div>

    <slot name="footer">
      <div class="d-flex align-items-center justify-content-center mt-20">
        <a
          href="https://support.hubstaff.com/referral-program-work/#Terms-and-conditions"
          target="_blank"
          rel="noopener noreferrer"
        >
          Terms and Conditions
        </a>
      </div>
    </slot>
  </AppDialog>
</template>

<script>
import { UserResource } from '~/resources';

export default {
  name: 'NewReferralDialog',
  data: () => ({
    show: false,
    email: null,
    userName: null,
    referralCode: null,
    signupUrl: null,
    errors: null,
    sending: false,
  }),
  computed: {
    referralLink() {
      return `${this.signupUrl}?referral_code=${this.referralCode}&referrer=${this.userName}`;
    },
    sendEmailButtonText() {
      return this.sending ? 'Sending...' : 'Send invite';
    },
    subtitle() {
      return `Receive a $300 gift card when you refer someone to Hubstaff who creates a
      new organization and subscribes to a paid annual plan with at least 5 seats.`;
    },
  },
  methods: {
    open(userName, referralCode, signupUrl) {
      this.show = true;
      this.userName = userName;
      this.referralCode = referralCode;
      this.signupUrl = signupUrl;

      if (!this.referralCode) {
        this.retrieveReferralCode();
      }
    },
    close() {
      this.show = false;
      this.errors = null;
    },
    async sendInvite(email) {
      if (!email) {
        this.errors = 'Email is required';

        return;
      }

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (!emailRegex.test(email)) {
        this.errors = 'Invalid email address';

        return;
      }

      this.sending = true;

      try {
        await UserResource.sendReferralInvite({}, { email });
        this.email = null;
        this.errors = null;
        this.$appMessage('Invite sent');
      } catch (error) {
        this.errors = error.response?.data?.error || 'An error occurred while sending the invite.';
      } finally {
        this.sending = false;
      }
    },
    async retrieveReferralCode() {
      try {
        const response = await UserResource.retrieveReferralCode();

        this.referralCode = response.referral_code;
      } catch (error) {
        this.$appMessage('Unexpected error. Please try again.');
      }
    },
  },
};
</script>
